module.exports = __webpack_public_path__ + "static/media/screen-location-lowerright.99992b65.svg";